/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import { dataContentRadioData, dataSourceRadioData } from '../utils/constant';
import * as TYPES from './action-types';

const intialState = {
  loading: false,
  searchFilter: {
    planType: 'ST',
    rpc: null,
    priceType: null,
    calcQtr: null,
    dataContent: dataContentRadioData[0].value,
    dataSource: dataSourceRadioData[0].value,
  },
  defaultQtrRDP: null,
  userDefault: null,
  priceTypeData: [],
  rebateProgramData: [],
  priceLoadMFGData: [],
  priceLoadDetailsFilter: null,
  referenceData: null,
  priceLoadDetailsChanged: false,
  priceLoadDetailsLoaded: false,
  priceLoadDetailsTableData: null,
  comparePriceLoadDetailsTableData: null,
  trigerGetComentsExist: 0,
};

const reducer = (state = intialState, action) => {
  switch (action.type) {
    case TYPES.REQUEST_DRUG_PRICE_LOAD_LOADING:
      return { ...state, loading: action.payload };
    case TYPES.REQUEST_DRUG_PRICE_LOAD_SEARCH_FILTER:
      return { ...state, searchFilter: action.payload };
    case TYPES.REQUEST_DRUG_PRICE_LOAD_DEFAULT_QUATER:
      return { ...state, defaultQtrRDP: action.defaultQtrRDP };
    case TYPES.CUSTOM_ADDDATA_URA:
      return { ...state, addURA: action.payload };
    case TYPES.REQUEST_DRUG_PRICE_LOAD_USER_DEFAULT:
      return { ...state, userDefault: action.payload };
    case TYPES.REQUEST_DRUG_PRICE_LOAD_PRICE_TYPE_DATA:
      return { ...state, priceTypeData: action.payload };
    case TYPES.REQUEST_DRUG_PRICE_LOAD_REBATE_PROGRAM_DATA:
      return { ...state, rebateProgramData: action.payload };
    case TYPES.REQUEST_DRUG_PRICE_LOAD_MFG_TABLE_DATA:
      return { ...state, priceLoadMFGData: action.payload };
    case TYPES.REQUEST_DRUG_PRICE_LOAD_DETAILS_FILTER:
      return { ...state, priceLoadDetailsFilter: action.payload };
    case TYPES.REQUEST_DRUG_PRICE_LOAD_DETAILS_REFERENCE_DATA:
      return { ...state, referenceData: action.payload };
    case TYPES.REQUEST_DRUG_PRICE_LOAD_DETAILS_CHANGED:
      return { ...state, priceLoadDetailsChanged: action.payload };
    case TYPES.UPLOAD_SAVE_DISABLE:
      return { ...state, upload_save_disable: action.payload };
    case TYPES.REQUEST_DRUG_PRICE_LOAD_DETAILS_TABLEDATA:
      return { ...state, priceLoadDetailsTableData: action.payload };
    case TYPES.REQUEST_DRUG_PRICE_LOAD_DETAILS_TABLEDATA_LOADED:
      return { ...state, priceLoadDetailsLoaded: action.payload };
    case TYPES.REQUEST_DRUG_PRICE_LOAD_DETAILS_COMPARE_TABLEDATA:
      return { ...state, comparePriceLoadDetailsTableData: action.payload };
    case TYPES.TRIGER_COMMENTS_EXIST_CHECK:
      return { ...state, trigerGetComentsExist: action.payload };
    case TYPES.RESET_REQUEST_DRUG_PRICE_LOAD_STORE:
      return action.payload ? { ...intialState } : state;
    case TYPES.CURRENT_CORR_LINK_ID:
      return {...state , currentCorrLinkID:action.payload}  
    default:
      return state;
  }
};

export default reducer;
